export function mapNamedIdOptions(items) {
  return (items ?? []).map((item) => ({
    value: String(item.id),
    label: item.name,
  }));
}
